import { Dashboard, Bookmark, Lock } from '@mui/icons-material';
import { PATH_DASHBOARD } from '../../../routes/paths';

const subAdminNavConfig = [
  {
    items: [
      { title: 'Dashboard', path: PATH_DASHBOARD.subAdminRole.dashboard, icon: <Dashboard /> },
      { title: 'Watchlist', path: PATH_DASHBOARD.subAdminRole.watchlist.root, icon: <Bookmark /> },
      {
        title: 'Change Password',
        path: PATH_DASHBOARD.subAdminRole.setting.changePassword,
        icon: <Lock />,
      },
    ],
  },
];

export default subAdminNavConfig;
